export { default } from "./getTrialLicenseFarthestExpirationDate";
